import React, { memo } from 'react'
import { Text } from '@chakra-ui/core'
import colors from 'constants/colors'
import LocaleText from 'components/LocaleText'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { formatTimestamp } from 'utils'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import strings from 'constants/strings'

dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.extend(timezone)

interface ILastEtlRuntimeProps {
  lastEtlRuntime: string
}

export const LastEtlRuntime = memo(({ lastEtlRuntime }: ILastEtlRuntimeProps) => {
  const { theme } = useSelector((state: RootState) => state.general)

  if (!lastEtlRuntime) {
    return null
  }

  const hasTime = /\d{2}:\d{2}/.test(lastEtlRuntime)
  const inputFormat = hasTime
    ? strings.DATE_FORMATS.outputs.CREATED_AT_TS_FORMAT
    : strings.DATE_FORMATS.outputs.CREATED_AT_TS_WITHOUT_TIME

  const outputFormat = theme?.is_support_us_date_format
    ? hasTime
      ? strings.DATE_FORMATS.outputs.CREATED_AT_TS_US_FORMAT
      : strings.DATE_FORMATS.outputs.CREATED_AT_TS_WITHOUT_TIME_US
    : hasTime
    ? strings.DATE_FORMATS.outputs.CREATED_AT_TS_FORMAT
    : strings.DATE_FORMATS.outputs.CREATED_AT_TS_WITHOUT_TIME

  const formattedTime = formatTimestamp(lastEtlRuntime, outputFormat, inputFormat)

  return (
    <Text minW="100px" color={colors.greyDark} fontSize="14px">
      <Text as={'span'} fontFamily='"Asap Condensed", sans-serif'>
        <LocaleText text={'last_run'} />
        :&nbsp;
      </Text>
      <Text as={'span'} fontFamily='"Asap Condensed", sans-serif'>
        {formattedTime}
      </Text>
    </Text>
  )
})
